export default __webpack_public_path__ + "static/media/api_document_inactive.8f55950d.svg";